import { Card, Stack, Typography } from '@mui/material'

import envConfig from '../configs/env'
import type { Location, LocationInstruction } from '../types'

type CustomInstructionsProps = {
  station: Location
}
export default function CustomInstructions({ station }: CustomInstructionsProps) {
  const instructions = station.instructions ?? []

  return instructions.length > 0 ? (
    <Card
      elevation={0}
      sx={{ p: 2, backgroundColor: 'success.main', color: 'success.contrastText', borderRadius: 2, mb: 3 }}
    >
      <Stack spacing={2}>
        {instructions.map((instruction) => (
          <InstructionDetail key={instruction.title} instruction={instruction} locationId={station.id} />
        ))}
      </Stack>
    </Card>
  ) : null
}

type InstructionDetailProps = {
  instruction: LocationInstruction
  locationId: string
}

function InstructionDetail({ instruction, locationId }: InstructionDetailProps) {
  const { title, description, isMobileAppLink } = instruction
  return (
    <Stack>
      <Typography variant="h6" sx={{ fontWeight: 700, color: 'inherit' }}>
        {title}
      </Typography>

      <Typography variant="body1" sx={{ color: 'inherit' }}>
        {isMobileAppLink ? (
          <a style={{ color: 'inherit' }} href={`${envConfig.mobileLinkHandlerUrl}/locations/${locationId}`}>
            {description}
          </a>
        ) : (
          description
        )}
      </Typography>
    </Stack>
  )
}
